// extracted by mini-css-extract-plugin
module.exports = {"container":"container_Fzdmm","lang":"lang_UIA+V","content":"content_Rmqe9","top":"top_pTsRU","header":"header_ONjK4","logo":"logo_gn3ou","title":"title_sVnPU","desc":"desc_hegX7"};